import { PeopleCostCentreDto } from '../people-cost-centre.dto';
import { PeopleMerchantDto } from '../people-merchant.dto';
import { PeopleMerchantGroupDto } from '../people-merchant-group.dto';
import { PeopleRosterDto } from '../people-roster.dto';
import { PeopleEmployeeBankDetailsDto } from './people-employee-bank-details.dto';
import { PeopleEmployeeClockInOutDto } from './people-employee-clock-in-out.dto';
import { PeopleEmployeeContractDto } from './people-employee-contract.dto';
import { PeopleEmployeeFileDto } from './people-employee-file.dto';
import { PeopleEmployeeLeaveDto } from './people-employee-leave.dto';
import { PeopleEmployeeNextOfKinDto } from './people-employee-next-of-kin.dto';
import { PeopleEmployeePersonalDetailsDto } from './people-employee-personal-details.dto';
import { PeopleEmployeeVisaDto } from './people-employee-visa.dto';
import { PeopleEmployeeWorkProfileDto } from './people-employee-work-profile.dto';
import { PeopleQueryBaseDto } from '../people-query-base.dto';

export class PeopleEmployeeDto {
  id?: number;
  firstName?: string;
  lastName?: string;
  employeeNumber?: string;
  knownAs?: string;
  isActive?: boolean;
  startDate?: Date;
  endDate?: Date;
  merchantGroupId?: number;
  costCentreId?: number;
  merchantId?: number;
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;
  additionalCostCentreIds?: number[];

  rosters?: PeopleRosterDto[];
  leaves?: PeopleEmployeeLeaveDto[];
  coveringLeaves?: PeopleEmployeeLeaveDto[];
  workProfile?: PeopleEmployeeWorkProfileDto;
  bankDetails?: PeopleEmployeeBankDetailsDto;
  contract?: PeopleEmployeeContractDto;
  clockInOut?: PeopleEmployeeClockInOutDto[];
  nextOfKin?: PeopleEmployeeNextOfKinDto;
  personalDetails?: PeopleEmployeePersonalDetailsDto;
  visa?: PeopleEmployeeVisaDto;
  files?: PeopleEmployeeFileDto[];
  merchantGroup?: PeopleMerchantGroupDto;
  costCentre?: PeopleCostCentreDto;
  merchant?: PeopleMerchantDto;
}

export interface PeopleEmployeeQueryDto extends PeopleQueryBaseDto {
  name?: string;
  jobTitleId?: number;
  merchantGroupId?: number;
  departmentId?: number | number[];
  excludeDepartmentId?: number;
  merchantId?: number;
  coverStartDate?: Date;
  isActive?: boolean;
  include?: string[];
}
